import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { StepEnum } from '@/api-sdk';
import { StoreController } from '@/controllers';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { configuratorStore } from '@/stores';
import { baseStyles } from '@/styles';

import '../messages/fg-message';

@customElement('fg-configurator-step')
export class FgConfiguratorStep extends LitElement {
  private validationStoreController = new StoreController(
    this,
    configuratorStore,
    state => {
      this.validationMessages = state.validationMessages;
      this.showValidationMessage = state.showValidationMessage;
    },
  );

  @property({ type: String })
  stepTitle: string | null = '';

  @property({ type: String })
  stepType?: StepEnum;

  @property({ type: String })
  validationMessage?: string | null;

  @state()
  showValidationMessage = configuratorStore.getState().showValidationMessage;

  @state()
  validationMessages = configuratorStore.getState().validationMessages;

  render() {
    return html`
      <section>
        <header>
          <h2>${this.stepTitle}</h2>
          <slot name="step-header"></slot>
        </header>
        ${this.stepType &&
        this.validationMessages[this.stepType] &&
        this.showValidationMessage
          ? html`
              <fg-message
                part="retail"
                .message=${this.validationMessages[this.stepType] ?? undefined}
                type="error"
              ></fg-message>
            `
          : nothing}
        <slot></slot>
      </section>
    `;
  }

  static styles = [
    baseStyles,
    css`
      header {
        display: flex;
        align-items: start;
        justify-content: space-between;
        flex-direction: column;
        gap: 10px;

        @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
          && {
            align-items: center;
            flex-direction: row;
            gap: 0px;
          }
        }
      }

      fg-message {
        display: block;
        margin-bottom: 20px;
      }

      h2 {
        font-size: 1.25rem;
        font-weight: 600;
      }
    `,
  ];
}
